<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.totalUpdate"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Pago Intención</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <form @submit.prevent="dialogSavePay = true" v-if="!isLoading">
            <div class="override_content_flex pa-5" >
                <div class="col-flex-4">
                    <v-text-field
                        label="Cantidad"
                        variant="outlined"
                        type="number"
                        v-model="formGroup.data.pago"
                        :rules="formGroup.rules.pago"
                        placeholder="Ingrese la cantidad a pagar"
                        class="w-100"
                        onkeydown="return event.key !== 'e'"
                        @wheel.prevent
                        @keydown="blockKeys"
                    ></v-text-field>
                </div>
                <div class="col-flex-4">
                    <v-text-field 
                        label="Fecha Pago Inicial"
                        variant="outlined"
                        v-model="formGroup.data.fecha"
                        :rules="formGroup.rules.fecha"
                        class="w-100"
                        :min="minDate"
                        type="date"
                    ></v-text-field>
                </div>
                <div class="col-flex-4">
                    <v-text-field
                        label="Hora Pago Intención"
                        variant="outlined"
                        v-model="formGroup.data.hora"
                        :rules="formGroup.rules.hora"
                        placeholder="Ingrese la cantidad a pagar"
                        class="w-100"
                        type="time"
                    ></v-text-field>
                </div>
                <div v-if="catalogSettings.dictamen_mode === 'independent'" class="col-flex-12">
                    <v-select v-model="idDictamen" :items="dictamenes" item-title="descripcion" item-value="id_dictamen"
                        :label="catalogSettings.dictamen_label" variant="outlined" />
                </div>
                <div class="col-flex-12">
                    <v-textarea
                        label="Observaciones"
                        v-model="formGroup.data.observaciones"
                        :rules="formGroup.rules.observaciones"
                        variant="outlined"
                        maxLength="160"
                        rows="2"
                        @paste.prevent
                        @keydown.enter.prevent
                    ></v-textarea>
                    <div align="end" style="letter-spacing: 1px;">
                    {{ formGroup.data.observaciones.length }}/160
                    </div>
                </div>

            <div class="col-flex-12" 
                v-if="infoClient.estado === 'Convenio Completado'">
                <i>No es posible dar pagos porque no existe un convenio</i>
            </div>

            <div class="col-flex-12" align="end">
                <v-btn
                    variant="flat"
                    color="indigo-darken-3"
                    class="ml-2 text-none"
                    :disabled="validateFormPay() || infoClient.estado === 'Convenio Completado'"
                    type="submit"
                    prepend-icon="mdi-content-save-all"
                    text="Guardar"
                ></v-btn>
            </div>
            </div>
        </form>
    </div>

    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando Formulario de Pago Intención</div>
    </div>

    <template>
      <v-dialog v-model="dialogSavePay" width="500px" persistent>
          <v-card>
              <v-card-title>
                  <span class="text-h5">Confirmación</span>
              </v-card-title>
              <v-card-text>
                <div v-if="!isLoading">
                  <div class="text-center">
                    <img src="@/assets/images/warning.png">
                  </div>
                  <div class="description-text">
                      <p>¿Está seguro de registrar el pago intención?</p>
                  </div>
                </div>
                <div class="content_load" v-if="isLoading">
                  <v-progress-circular
                    :size="100"
                    :width="7"
                    color="indigo-darken-3"
                    indeterminate
                  ></v-progress-circular>
                  <i>Espere un momento</i>
                  <div>Registrando la información</div>
                </div>
              </v-card-text>
              <v-card-actions class="actions_buttons">
                  <v-btn 
                    variant="flat"
                    class="text-none"
                    color="red"
                    @click="dialogSavePay = false">Cerrar</v-btn>
                  <v-btn 
                    variant="flat"
                    class="text-none"
                    color="indigo-darken-3"
                    @click="saveIntentionPayment()" 
                    :loading="idLoading">Aceptar</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSelectedDate.open" width="400px" persistent>
            <v-card>
                <v-card-title>Seleccione una Fecha</v-card-title>
                <v-card-text>
                    <v-date-picker
                        v-model="dialogSelectedDate.data" 
                        :min="minDate"
                        @update:model-value="setDate()"
                        :hide-header="true"
                    ></v-date-picker>
                </v-card-text>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSelectedTime.open" width="230px" persistent>
            <v-card>
                <v-card-title>Seleccione una Hora</v-card-title>
                <v-card-text>
                    <div class="container_time mb-8">
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('HOUR', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.hour"
                                    ></v-text-field>
                                </div>
                                <div class="separate_time">:</div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('HOUR', '-')"></v-btn>
                            </div>
                        </div>
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('MINUTE', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.minute"
                                    ></v-text-field>
                                </div>
                                <div class="separate_time">:</div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('MINUTE', '-')"></v-btn>
                            </div>
                        </div>
                        <div class="item_time">
                            <div class="time_button mb-5">
                                <v-btn icon="mdi-menu-up" variant="text" @click="changeTime('TYPE', '+')"></v-btn>
                            </div>
                            <div class="display_flex">
                                <div class="item_data_time">
                                    <v-text-field
                                        readonly
                                        variant="outlined"
                                        v-model="dialogSelectedTime.data.type"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="time_button">
                                <v-btn icon="mdi-menu-down" variant="text" @click="changeTime('TYPE', '-')"></v-btn>
                            </div>
                        </div>
                        
                    </div>
                </v-card-text>
                <v-card-actions style="display: flex; justify-content: center;">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="closeTime()"
                        text="Cancelar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="setTime()"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import { useManagementCatalogStore } from '@/stores/managementCatalog';
import ClientSummary from '@/components/managements/ClientSummary.vue'
import SnackbarComponent from '@/components/Snackbar'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService';
import { ResourcesService } from '@/services/ResourcesService';
import { useUiStore } from '@/stores/ui'
export default {
    name: "PaymentIntentionView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            idDictamen: null, catalogConfigError: true,
            isLoading: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dialogSavePay: false,
            idClient: '',
            formGroup: {
                data: {
                    id_usuario: '',
                    id_cliente: '',
                    fecha: '',
                    hora: '',
                    observaciones: '',
                    username: '',
                    pago: '',
                },
                rules: {
                    pago: [
                        value => {
                        if (value === '') {
                            return 'El campo Cantidad con es obligatorio'
                        }
                        if(parseFloat(value) > parseFloat(this.infoClient.total)) {
                            return `El campo Cantidad no debe ser mayor a ${this.infoClient.totalUpdate}`
                        }
                        if(parseFloat(value) < 0) {
                            return `El campo Cantidad no debe ser menor a 0`
                        }
                        return true
                        }
                    ],
                    fecha: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Fecha con es obligatorio'
                        }
                    ],
                    hora: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Próximo Contacto es obligatorio`
                            }

                            if (!value) return "Debe ingresar una hora";

                            const [HOUR, MINUTE] = value.split(":").map(Number);

                            if (HOUR === 21 && MINUTE > 0) return "El horario no es válido";

                            if (HOUR < 8 || HOUR > 21) return "El horario no es válido";

                            return true;
                        }
                    ],
                    observaciones: [
                        value => {
                        if (value === '') {
                            return 'El campo Observaciones con es obligatorio'
                        }
                        if (!/^[a-zA-Z0-9./\s]*$/.test(value)) {
                            return 'Solo se permiten letras, números, puntos (.) y barras (/)';
                        }
                        return true
                        }
                    ],
                }
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
            dialogSelectedDate: {
                option: '',
                open: false,
                data: new Date(),
            },
            dialogSelectedTime: {
                option: '',
                open: false,
                data: {
                    hour: '08',
                    minute: '00',
                    type: 'AM',
                },
            },
            minDate: new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
        }
    },
    computed:{
        catalogSettings() { return useManagementCatalogStore().settings; },
        dictamenes() { return useManagementCatalogStore().dictamenes; },
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        try {
            await useManagementCatalogStore().load();
            this.catalogConfigError = false;
        } catch (e) { this.snackbarData = { openSnackbar: true, description: 'No se pudo cargar la configuración de gestión.' }; }

        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        this.isLoading = true
        await this.getClientInformation()
        this.isLoading = false
    },
    methods: {
        blockKeys(event) {
            if (["ArrowUp", "ArrowDown", "e"].includes(event.key)) {
                event.preventDefault();
            }
        },
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (responseData.error === false) {
                        this.infoClient = responseData.response
                        this.infoClient.totalUpdate = ResourcesService.moneyFormat(parseInt(this.infoClient.total))
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = typeof responseData.msg === 'string' ? responseData.msg : Object.values(responseData.msg || {}).flat().join(' ') || responseData.message
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        validateFormPay: function () {
            if (this.catalogConfigError || (this.catalogSettings.dictamen_mode === 'independent' && !this.idDictamen)) return true;
            let fecha = this.formGroup.data.fecha
            if (fecha === '' || fecha === null || fecha === undefined) {
                return true
            }
            let hora = this.formGroup.data.hora
            if (hora === '' || hora === null || hora === undefined) {
                return true
            }
            const HOUR = hora.split(':')[0];
            const MINUTE = hora.split(':')[1];
            if (
                (HOUR === '21' && parseInt(MINUTE) > 0) || HOUR === '22' || 
                HOUR === '23' || HOUR === '24' || HOUR === '01' || 
                HOUR === '02' || HOUR === '03' || HOUR === '04' || 
                HOUR === '05' || HOUR === '06' || HOUR === '07'
            ) {
                return true
            }
            let observaciones = this.formGroup.data.observaciones
            if (observaciones === '' || observaciones === null || observaciones === undefined) {
                return true
            }
            let pago = this.formGroup.data.pago
            if (pago === '' || pago === null || pago === undefined) {
                return true
            }
            
            return false
        },
        saveIntentionPayment: async function () {
            if (this.catalogConfigError) return;

            this.isLoading = true

            let id_usuario = await EncryptService.encrypt(localStorage.getItem('ID'))
            let id_cliente = await EncryptService.encrypt(this.idClient)
            let fecha = this.formGroup.data.fecha
            let hora = this.formGroup.data.hora
            let observaciones = this.formGroup.data.observaciones.toString().trim()
            let pago = this.formGroup.data.pago
            let username = await EncryptService.decrypt(localStorage.getItem('USERNAME'))

            const FORMDATA = {
                id_usuario: id_usuario,
                id_cliente: id_cliente,
                fecha: fecha,
                hora: hora,
                observaciones: observaciones,
                username: username,
                pago: pago,
                id_dictamen: this.idDictamen,
            }

            await ManagementsService.saveIntentionPayment(FORMDATA).then(
            async (responseData) => {
                if (responseData.error === false) {
                    this.snackbarData.description = `¡Registro Exitoso!`
                    this.snackbarData.openSnackbar = true

                    this.formGroup.data.fecha = ''
                    this.formGroup.data.hora = ''
                    this.formGroup.data.observaciones = ''
                    this.formGroup.data.pago = ''

                    this.tabMenu = 0
                    this.dialogSavePay = false

                    } else {
                        this.snackbarData.description = typeof responseData.msg === 'string' ? responseData.msg : Object.values(responseData.msg || {}).flat().join(' ') || responseData.message
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        selectedDate: function (TYPE_OPTION) {
            this.dialogSelectedDate.option = TYPE_OPTION
            this.dialogSelectedDate.open = true
        },
        selectedTime: function (TYPE_OPTION) {
            this.dialogSelectedTime.option = TYPE_OPTION
            this.dialogSelectedTime.open = true
        },
        setDate: function () {
            const OPTION = this.dialogSelectedDate.option
            const YEAR_INPUT = this.dialogSelectedDate.data.getFullYear();
            const MONTH_INPUT = ('0' + (this.dialogSelectedDate.data.getMonth() + 1)).slice(-2);
            const DAY_INPUT = ('0' + this.dialogSelectedDate.data.getDate()).slice(-2);

            const DATE_SELECTED = `${DAY_INPUT}-${MONTH_INPUT}-${YEAR_INPUT}`

            switch (OPTION) {
                case 'INTENCION':
                    this.formGroup.data.fecha = DATE_SELECTED
                    break
            }
            this.dialogSelectedDate.open = false
        },
        changeTime: function (TYPE_TIME, OPTION) {
            if (TYPE_TIME === 'HOUR') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let minute = parseInt(this.dialogSelectedTime.data.minute)
                let type = this.dialogSelectedTime.data.type

                if (OPTION === '+') {
                    if (type === 'AM') {
                        if (hour + 1 === 12) {
                            hour = 12
                            // minute = 0
                            type = 'PM'
                        } else {
                            hour += 1
                        }
                        
                    } else if (type === 'PM') {
                        if (hour + 1 === 10) {
                            hour = 8
                            minute = 0
                            type = 'AM'
                        } else if (hour + 1 === 13) {
                            hour = 1
                            type = 'PM'
                        } else if (hour + 1 === 9) {
                            hour = 9
                            minute = 0
                        }else {
                            hour += 1
                        }
                    }
                } else if (OPTION === '-') {
                    if (type === 'AM') {
                        if (hour - 1 === 7) {
                            hour = 9
                            minute = 0
                            type = 'PM'
                        } else {
                            hour -= 1
                        }
                    } else if (type === 'PM') {
                        if (hour === 1) { 
                            hour = 12
                            type = 'PM'
                        } else if (hour === 12) { 
                            hour = 11
                            type = 'AM'
                        } else {
                            hour -= 1
                        }
                    }
                }
                
                this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                this.dialogSelectedTime.data.minute = minute < 10 ? `0${minute}` : `${minute}`  
                this.dialogSelectedTime.data.type = type
                return;
            }
            if (TYPE_TIME === 'MINUTE') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let minute = parseInt(this.dialogSelectedTime.data.minute)
                let type = this.dialogSelectedTime.data.type

                if (OPTION === '+') {
                    if (type === 'AM') {
                        if (minute + 1 === 60) {
                            this.changeTime('HOUR', '+')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 0
                        } else {
                            minute += 1
                        }
                    } else if (type === 'PM') {
                        if (minute + 1 === 60 || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '+')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 0
                        } else {
                            minute += 1
                        }
                    }
                } else if (OPTION === '-') {
                    if (type === 'AM') {
                        if ((minute - 1 === -1) || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '-')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            if (hour === 9 && type === 'PM') {
                                minute = 0
                            } else {
                                minute = 59
                            }
                        } else {
                            minute -= 1
                        }
                    } else if (type === 'PM') {
                        if ((minute - 1 === -1) || (hour === 9 && minute >= 0)) {
                            this.changeTime('HOUR', '-')
                            hour = parseInt(this.dialogSelectedTime.data.hour)
                            type = this.dialogSelectedTime.data.type
                            minute = 59
                        } else {
                            minute -= 1
                        }
                    }
                }

                this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                this.dialogSelectedTime.data.minute = minute < 10 ? `0${minute}` : `${minute}`  
                this.dialogSelectedTime.data.type = type
                return;
            }
            if (TYPE_TIME === 'TYPE') {
                let hour = parseInt(this.dialogSelectedTime.data.hour)
                let type = this.dialogSelectedTime.data.type
                if (type === 'AM') {
                    type = 'PM'
                    if (hour > 9) {
                        hour = 9;
                        this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                    }
                } else if (type === 'PM') {
                    type = 'AM'
                    if (hour < 8) {
                        hour = 8;
                        this.dialogSelectedTime.data.hour = hour < 10 ? `0${hour}` : `${hour}`
                    }
                }
                this.dialogSelectedTime.data.type = type
            }
        },
        closeTime: function () {
            this.dialogSelectedTime.data.hour = '08'
            this.dialogSelectedTime.data.minute = '00'
            this.dialogSelectedTime.data.type = 'AM'
            this.dialogSelectedTime.option = ''
            this.dialogSelectedTime.open = false
        },
        setTime: function () {
            let HOUR = this.dialogSelectedTime.data.hour
            let MINUTE = this.dialogSelectedTime.data.minute
            let SECOND = '00'
            let TYPE = this.dialogSelectedTime.data.type

            if (TYPE === 'PM') {
                let hourInt = parseInt(HOUR) + 12;
                if (hourInt === 24) {
                    hourInt = '00'
                }
                HOUR = hourInt
            }

            const TIME_CLOCK = `${HOUR}:${MINUTE}:${SECOND}`
            const OPTION = this.dialogSelectedTime.option

            switch (OPTION) {
                case 'INTENCION':
                    this.formGroup.data.hora = TIME_CLOCK
                    break
                default:
                    this.snackbarData.description = `Opción no disponible`
                    this.snackbarData.openSnackbar = true
            }
            this.dialogSelectedTime.open = false
        },
    }
}
</script>
<style scoped>

    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }

    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }


    .container_time {
        width: 100%; 
        display: flex; 
        flex-direction: row; 
        flex-wrap: wrap;
    }

    .item_time {
        width: calc(100%  / 3); 
        display: flex; 
        flex-direction: column;
    }

    .time_button {
        display: flex; 
        align-items: center; 
        justify-content: center; 
        margin-right: 6px;
    }

    .item_data_time {
        width: calc(100% - 5px);
    }

    .separate_time {
        width: 5px; 
        font-size: 26pt; 
        margin-right: 6px;
    } 
</style>